import {
  redirectionToLoginPage,
  logout as performLogout,
  getUserAfterLogin as getUser,
  handleRedirect as performRedirect,
  isUserAuthenticated as isAuthenticated,
  getAccessToken as getToken,
  getUserRoles,
  getScopes,
  getClientsPermissions as getClientsAuthorization,
} from '../../dependency-injection'

export const useAuthentication = () => {
  const login = (params) => redirectionToLoginPage.execute(params)
  const logout = () => performLogout.execute()
  const handleRedirect = () => performRedirect.execute()
  const getUserAfterLogin = () => getUser.execute()
  const isUserAuthenticated = () => isAuthenticated.execute()
  const getAccessToken = () => getToken.execute()
  const getRoles = () => getUserRoles.execute()
  const getUserScopes = () => getScopes.execute()
  const getClientsPermissions = async () => getClientsAuthorization.execute()

  return {
    login,
    logout,
    getUserAfterLogin,
    handleRedirect,
    isUserAuthenticated,
    getAccessToken,
    getRoles,
    getClientsPermissions,
    getUserScopes,
  }
}
